import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { EditFooter as EditFooterContainer } from "./timeReportDetailsPanel.styled";

type SaveAction =
  | { kind: "enabled"; saveLabel: string; isSaveEnabled: true }
  | { kind: "disabled"; saveLabel: string; isSaveEnabled: false };

interface EditFooterProps {
  cancelLabel: string;
  saveAction: SaveAction;
  isActionLoading: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const EditFooter = (props: EditFooterProps): JSX.Element => {
  return (
    <EditFooterContainer>
      <SecondaryButton
        type="button"
        size="small"
        label={props.cancelLabel}
        onClick={props.onCancel}
        disabled={props.isActionLoading}
      />
      <PrimaryButton
        type="button"
        size="small"
        label={props.saveAction.saveLabel}
        onClick={props.onSave}
        disabled={!props.saveAction.isSaveEnabled || props.isActionLoading}
        isLoading={props.isActionLoading}
      />
    </EditFooterContainer>
  );
};
